import React, { HTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';
import { MarketDivider } from '@market/react';
import { getLegalUrls } from 'typescript/utilities/links';
import { PaymentSchedule } from 'typescript/constants/enums/payment';

interface DisclaimerProps extends HTMLAttributes<HTMLElement> {
  applicationFlowToken?: string;
  disclosureDocumentToken?: string;
  paymentSchedule: PaymentSchedule;
  financingUiEnabled?: boolean;
  showDivider?: boolean;
}

const Disclaimer = ({
  className = '',
  applicationFlowToken = null,
  paymentSchedule,
  financingUiEnabled = false,
  showDivider = true,
}: DisclaimerProps) => {
  const { t } = useTranslation();

  const legalUrls = getLegalUrls(applicationFlowToken);

  const installment = (): string => {
    return t('checkout.payment_v3.payInInstallments.disclaimer', legalUrls);
  };

  const upfront = (): string =>
    t('checkout.payment_v3.payInFull.disclaimer', legalUrls);

  let disclaimerText: string;
  switch (paymentSchedule) {
    case 'installment': {
      disclaimerText = financingUiEnabled ? upfront() : installment();
      break;
    }
    default: {
      disclaimerText = upfront();
    }
  }

  return (
    <div className={className}>
      {showDivider && (
        <div className="shop-grid-item-full">
          <MarketDivider size="thin" />
        </div>
      )}
      <p className={`shop-grid-item-full paragraph-20`}>
        <div dangerouslySetInnerHTML={{ __html: disclaimerText }} />
      </p>
    </div>
  );
};

export default Disclaimer;
